/* eslint-disable no-shadow */
import React from 'react';

import styled, { css } from 'styled-components';
import { theme, Icon, DatePicker } from 'fpay-ui';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { useAuth } from '@hooks';
import SelectType from '../SelectType';
import { isAllowed } from '@helpers/auth';

const fontTypes = {
  title: css`
    ${({ theme }) => theme.textTypes['Subtitle-1-w400']};
    line-height: normal;
    color: ${theme.colors.gray800};
  `,
  clean: css`
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    line-height: 1.71;
    text-align: center;
    color: ${theme.colors.gray500};
  `,
};

const LayoutMobile = styled.div`
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const LayoutTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-items: flex-start;
  align-items: center;
`;

const LayoutSelectTypeMobile = styled.div`
  margin-top: 16px;
  width: 100%;
  ${theme.breakpoint('md')} {
    display: flex;
    justify-content: center;
  }
`;

const LayoutCalendar = styled.div`
  ${theme.breakpoint('md')} {
    display: flex;
    justify-content: center;
    margin-right: 16px;
  }
`;

const LayoutCalendarMobile = styled.div`
  margin-top: 16px;
  width: 100%;
  #btn-drop-down-calendar {
    max-width: none;
  }
  ${theme.breakpoint('md')} {
    /* display: flex;
    justify-content: center; */
    max-width: 223px;
  }
`;

const TitleMobile = styled.div`
  ${fontTypes.title}
  margin-left: 20px;
  align-content: center;
  align-items: center;
`;
const LayoutIcon = styled.div`
  display: flex;
  cursor: pointer;
  align-content: center;
  align-items: center;
`;

const IconMobile = styled(Icon)`
  width: 24px;
  height: 24px;
`;
export const CleanMobile = styled.div(
  ({ theme }) => css`
    display: flex;
    min-width: 120px;
    width: 156px;
    height: 56px;
    ${fontTypes.clean};
    text-align: center;
    color: ${(props) =>
      props.btnActive ? `${theme.colors.gbrand500}` : `${theme.colors.gray500}`};
    font-size: ${(props) => (props.btnActive ? '16px' : '14px')};
    justify-items: center;
    align-items: center;
    cursor: ${(props) => (props.btnActive ? 'pointer' : '')};
    justify-content: center;
  `
);

export const ApplyMobile = styled.div(
  ({ theme }) => css`
    display: flex;
    min-width: 120px;
    width: 156px;
    height: 56px;
    border-radius: 4px;
    background-color: ${(props) =>
      props.btnActive ? `${theme.colors.gbrand500}` : `${theme.colors.gray400}`};
    box-shadow: ${(props) => (props.btnActive ? '0 8px 28px 0 rgba(0, 0, 0, 0.24)' : '')};
    ${fontTypes.title};
    text-align: center;
    justify-content: center;
    align-items: center;
    color: ${(props) => (props.btnActive ? '#ffffff' : 'rgba(162, 167, 186, 0.87)')};
    font-size: ${(props) => (props.btnActive ? '16px' : '14px')};
    cursor: ${(props) => (props.btnActive ? 'pointer' : '')};
  `
);

const LayoutBottomMobile = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin: auto;
  margin-bottom: 44px;
`;

const FiltersMobile = ({
  typeMovementMobile,
  typeSoftDescriptorMobile,
  isFilteredMobile,
  onDateChangeMobile,
  handleResetMobile,
  onClickApplyMobile,
  onClickBackMobile,
  onButtons,
  filters,
  optionsMovSoftType,
  optsMovType,
}) => {
  const { t } = useTranslation();
  const {
    merchant: { created_at: signedUpDate },
  } = useAuth();

  const showDetailFilter = isAllowed('LAST_MOVEMENTS_DETAIL_FILTER');
  return (
    <LayoutMobile>
      <LayoutTitle>
        <LayoutIcon onClick={onClickBackMobile}>
          <IconMobile icon="ic_backarrow" />
        </LayoutIcon>
        <TitleMobile>{t('lastMovements.filters')}</TitleMobile>
      </LayoutTitle>
      <LayoutSelectTypeMobile>
        <SelectType
          typeMovement={typeMovementMobile}
          isFiltered={isFilteredMobile}
          placeHolder={t('lastMovements.placeHolderFilter')}
          options={optsMovType}
        />
      </LayoutSelectTypeMobile>
      {showDetailFilter && (
        <LayoutSelectTypeMobile>
          <SelectType
            typeMovement={typeSoftDescriptorMobile}
            isFiltered={isFilteredMobile}
            placeHolder={t('lastMovements.placeHolderDetail')}
            options={optionsMovSoftType}
            transfer
          />
        </LayoutSelectTypeMobile>
      )}
      <LayoutCalendar>
        <LayoutCalendarMobile>
          <DatePicker
            onChange={({ init, finish }) =>
              onDateChangeMobile({ startDate: init, endDate: finish })
            }
            intervalDateSelect={{
              init: filters.startDate || undefined,
              finish: filters.endDate || undefined,
            }}
            placeholder="Seleccionar fecha"
            minDate={moment(signedUpDate).toDate()}
            maxDate={moment().toDate()}
          />
        </LayoutCalendarMobile>
      </LayoutCalendar>
      <LayoutBottomMobile>
        <CleanMobile onClick={handleResetMobile} btnActive={onButtons} testId="onClickTest">
          {t('lastMovements.clean')}
        </CleanMobile>

        <ApplyMobile onClick={onClickApplyMobile} btnActive={onButtons}>
          {t('lastMovements.apply')}
        </ApplyMobile>
      </LayoutBottomMobile>
    </LayoutMobile>
  );
};

export default FiltersMobile;
